<template>
    <div class="profile">
        <div class="container-fluid">
            <div class="row">
                <div class="login-card">
                    <div>
                        <div>
                            <h2 class="fw-bold">Profile</h2>
                        </div>
                        <div class="login-main ">
                            <div class="theme-form">
                                <div class="row">
                                    <div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">Username</label>
                                            <div class="col-sm-9">
                                                <input class="form-control border-dark" type="text" v-model="username"
                                                    required />
                                            </div>
                                        </div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">First Name</label>
                                            <div class="col-sm-9">
                                                <input class="form-control border-dark" type="text" v-model="firstName"
                                                    required />
                                            </div>
                                        </div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">Last Name</label>
                                            <div class="col-sm-9">
                                                <input class="form-control border-dark" type="text" v-model="lastName"
                                                    required />
                                            </div>
                                        </div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">Email</label>
                                            <div class="col-sm-9">
                                                <input class="form-control border-dark grey" type="email" v-model="email"
                                                    disabled required
                                                    style=" background-color: rgb(233, 231, 231) !important;" />
                                            </div>
                                        </div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">Role</label>
                                            <div class="col-sm-9">
                                                <input class="form-control border-dark grey" type="text" v-model="role"
                                                    required disabled
                                                    style=" background-color: rgb(233, 231, 231) !important;" />
                                            </div>
                                        </div>
                                        <PrimaryButton :disabled="false" @click="updateProfile()">Save
                                        </PrimaryButton>
                                    </div>
                                </div>
                            </div>

                            <div class="theme-form">
                                <div class="row">
                                    <div>
                                        <h4 class="fw-bold">Manage Password</h4>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">Current Password</label>
                                            <div class="col-sm-9">
                                                <div class="form-input position-relative">
                                                    <input class="form-control border-dark pass"
                                                        :type="active ? 'password' : 'text'" name="login[password]"
                                                        v-model="password" required />
                                                    <div class="show-hide">
                                                        <i class="fa fas" :class="active ? 'fa-eye' : 'fa-eye-slash'"
                                                            @click.prevent="show">
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">New Password</label>
                                            <div class="col-sm-9">
                                                <div class="form-input position-relative">
                                                    <input class="form-control border-dark pass"
                                                        :type="active ? 'password' : 'text'" v-model="newPassword"
                                                        required />
                                                    <div class="show-hide">
                                                        <i class="fa fas" :class="active ? 'fa-eye' : 'fa-eye-slash'"
                                                            @click.prevent="show">
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group mb-3 row">
                                            <label class="col-sm-3 col-form-label">Confirm Password</label>
                                            <div class="col-sm-9">
                                                <div class="form-input position-relative">
                                                    <input class="form-control border-dark pass"
                                                        :type="active ? 'password' : 'text'" v-model="confirmPassword"
                                                        required />
                                                    <div class="show-hide">
                                                        <i class="fa fas" :class="active ? 'fa-eye' : 'fa-eye-slash'"
                                                            @click.prevent="show">
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <PrimaryButton :disabled="false" @click="updatePassword()">Save
                                        </PrimaryButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import PrimaryButton from '@/components/PrimaryButton.vue';
import { getRequest, patchRequest, postRequest } from "@/services/RequestService";

export default {
    components: {
        PrimaryButton,
    },

    data() {
        return {
            active: true,
            username: "",
            firstName: "",
            lastName: "",
            email: "",
            role: "",
            password: "",
            newPassword: "",
            confirmPassword: "",
        }
    },
    methods: {
        show() {
            this.active = !this.active
        },

        async loadUser() {
            try {
                const authToken = localStorage.getItem("token");
                const user_details = JSON.parse(localStorage.getItem("user_details"));

                if (!authToken || !user_details) {
                    throw new Error("Authentication information is missing.");
                }

                const user_id = user_details.id;

                const response = await getRequest(`/users/${user_id}/view`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (response.data.success === false) {
                    throw new Error("Error encountered. Please try again.")
                }

                const userData = response.data.data;
                this.username = userData.username;
                this.firstName = userData.first_name;
                this.lastName = userData.last_name;
                this.email = userData.email;
                this.role = userData.roles.name;
                this.currentPassword = userData.password;

            } catch (error) {
                console.error("Error fetching API data:", error);
            }
        },

        async updateProfile() {
            try {

                const updatedUserProfile = {
                    username: this.username,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    email: this.email,
                    role: 1,
                    status: true,
                };

                const authToken = localStorage.getItem("token");
                const user_details = JSON.parse(localStorage.getItem("user_details"));

                const user = user_details.id;

                const response = await patchRequest(`/users/${user}/update`, updatedUserProfile, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (response.data.success) {
                    this.$swal({
                        icon: response.data.success ? "success" : "error",
                        text: response.data.message,
                        confirmButtonText: "Close",
                    });
                } else {
                    this.$swal({
                        icon: "error",
                        text: "Incomplete details. Please complete the form.",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#ffbc0d",
                    });
                }

                if (response.data.success === false) {
                    throw new Error("Error encountered. Please try again.");
                }

                console.log("User profile updated successfully!");

            } catch (error) {
                console.error("Error updating profile:", error);
            }
        },

        async updatePassword() {
            try {
                // Send an API request to update the user's password
                // Include the current password for verification on the server
                const requestData = {
                    current_password: this.password, // The user-entered current password
                    password: this.newPassword,   // The hashed new password
                    password_confirmation: this.confirmPassword,   // The hashed new password
                };

                const authToken = localStorage.getItem("token");

                const response = await patchRequest(`/users/update/password`, requestData, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (response.data.success) {
                    this.$swal({
                        icon: response.data.success ? "success" : "error",
                        text: response.data.message,
                        confirmButtonText: "Close",
                    });
                } else {
                    this.$swal({
                        icon: "error",
                        text: response.data.message,
                        confirmButtonText: "Close",
                        confirmButtonColor: "#ffbc0d",
                    });
                }

                this.password = null;

                if (response.data.success === false) {
                    throw new Error("Error encountered. Please try again.");
                }

                console.log("User Password updated successfully!");
            } catch (error) {
                console.error("Error updating password:", error);
            }
        },

    },

    async mounted() {
        await this.loadUser();
    }
}
</script>

<style scoped lang="scss">
.profile .login-card {
    justify-content: left;
}

.profile .login-card .login-main {
    width: 50rem;
}

.login-card .login-main .theme-form input {
    background-color: transparent !important;
}

button {
    float: right;
}

.pass input {
    color: grey;
}
</style>
    